<template>
  <section class="faq-container">
    <header>
      <h2>よくあるご質問</h2>
    </header>

    <div class="faq">
      <q-and-a :q="'いいね、コメントを取得できますか'">
        <div slot="a">
          <p>できません。</p>
          <p>Instagram Graph APIから取得できるデータには<code>like_count</code>や<code>comments_count</code>といったデータが含まれていますが、Instagram Graph APIのリクエスト回数が非常に限られているので、Instagramから取得したデータを更新することが実質的にできません。したがって、ほとんどの投稿について<code>like_count</code>も<code>comments_count</code>もゼロになってしまうため、本APIとしてはデータをご提供しておりません。</p>
        </div>
      </q-and-a>
    </div>
  </section>
</template>

<script>
import QAndA from './QAndA'
export default {
  components: {
    QAndA
  }
}
</script>
